module.exports = __webpack_public_path__ + "static/img/loading.f31331d.gif";


//////////////////
// WEBPACK FOOTER
// ./static/loading.gif
// module id = 6/Qk
// module chunks = 0